import React, {useState,useRef} from 'react';
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    Button,
    Theme,
    useMediaQuery,
    useTheme,
    Table,
    TableHead, TableRow, TableCell, TableBody, TableContainer, DialogActions,Alert
} from '@mui/material';
import {read, utils} from 'xlsx';

import LoadingProgress from "../../components/LoadingProgress";
import makeStyles from '@mui/styles/makeStyles';
import TopBarDialog from "../../components/topBar/TopBarDialog";
import Strings from "../../assets/strings";
import {ICliente} from "../../redux/types/ICliente";
import {formatPeso,formatDate} from "../../helpers";
import {importClientes} from "../../services";
import {mostrarClientes} from "../../redux/reducers/clientesReducer";
import {useAppDispatch} from "../../redux/hooks";

const useStyles = makeStyles((theme:Theme) => ({
    dialogPaper:{
        height: "100%"
    }
}));


export default function ImportarCliente({open,onClose}:{open:boolean,onClose:(open:boolean)=>void}) {
    const classes = useStyles();
    let dispatch = useAppDispatch();
    let form = useRef<HTMLFormElement>(null);

    const [error, setError] = useState("");
    const [clientes, setClientes] = useState<ICliente[]>([]);
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const smVewport = useMediaQuery(theme.breakpoints.down('md'));

    const handleChange =  (e:any)  => {
        e.preventDefault();
        setError("");
        let file;
        if (e.dataTransfer) {
            file = e.dataTransfer.files[0];
        } else if (e.target) {
            file = e.target.files[0];
        }
        if (!file) return false;
        if(file.type.indexOf("spreadsheetml") === -1) return setError(Strings.archivoNoPermitidoMsj)

        if(file.size > 20000000) return setError(Strings.archivoExcedeMsj+ ", 20MB!");

        if (file) {
            let fileReader = new FileReader();
            fileReader.onload = (event)=> {
                let data = event.target?.result;
                let workbook = read(data, {
                    type: "binary",
                    cellDates: true,
                    cellNF: false,
                    cellText: false
                });
                let wbName = workbook.SheetNames[0];
                let wbSheet = workbook.Sheets[wbName];
                utils.sheet_add_aoa(wbSheet, [[
                   "nombres",
                   "apellidos",
                   "email",
                   "cedula",
                   "sexo",
                   "fechaNacimiento",
                   "celular",
                   "telefono",
                   "ingresos",
                   "dependientes",
                   "direccion",
                ]] );


                let rowObject = utils.sheet_to_json<ICliente>(wbSheet, { raw: false, dateNF: 'YYYY-MM-DD'})
                let rowsData =  rowObject?.slice(2)?.map(item=>{
                    let sexo = item.sexo?.charAt(0)?.toLowerCase() === "f" ? "F":"M";
                    return {...item,sexo}
                })

                setClientes(rowsData)
                form?.current?.reset();
            };
            fileReader.readAsBinaryString(file);
        }

    }
    const close = () => {
        onClose(false);
        setClientes([])
    };
    const submit = () => {
        if(clientes?.length){

            let emails:string[] = [];
            let cedulas:string[] = [];
            let itemNoCedulas = false;

            clientes.forEach(e=>{
                if(!!e.email) emails.push(e.email);
                if(!!e.cedula){
                    cedulas.push(e.cedula)
                }else{
                    itemNoCedulas = true
                }
            })

            if(itemNoCedulas){
                return setError("El campo No. Identificación es obligatoria.")
            }else if(cedulas.length !== new Set(cedulas).size){
                return setError("Existen datos duplicados.")
            }else if(cedulas.length !== new Set(cedulas).size){
                return setError("Existen datos duplicados.")
            }

            setLoading(true)
            importClientes(clientes).then(()=>{
                dispatch(mostrarClientes());
                close()
            }).finally(()=>setLoading(false))
        }
    };
    return <>
        <Dialog
            open={open}
            maxWidth={"lg"}
            fullWidth={true}
            disableEscapeKeyDown
            fullScreen={smVewport}
            classes={{paper:classes.dialogPaper}}

        >

            {loading && <LoadingProgress/>}
            <TopBarDialog title={"Importar desde Excel"} onClose={close}>
                <Button color={"inherit"}  href="/pantillaImportarCliente.xlsx" download>DESCARGAR PLANTILLA</Button>
            </TopBarDialog>
            {error && <Alert color={"warning"} onClose={()=>setError("")}>{error}</Alert>}

            <DialogContent>
                <form id={"formUpload"} ref={form}>
                    <label>
                        <Box sx={{
                            p: 1.3,
                            border: "1px dashed",
                            textAlign: "center",
                            mb: 1
                        }}>
                            <Typography variant={"body2"} marginBottom={1}>Despues de descargar y completar la plantilla, adjuntar aquí. </Typography>
                            <input type="file" accept=".xlsx" onChange={handleChange}/>
                        </Box>
                    </label>
                </form>
                {!!clientes?.length &&
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{Strings.nombres}</TableCell>
                                    <TableCell>{Strings.apellidos}</TableCell>
                                    <TableCell>{Strings.email}</TableCell>
                                    <TableCell>{Strings.cedula}</TableCell>
                                    <TableCell>{Strings.sexo}</TableCell>
                                    <TableCell>{Strings.fechaNacimiento}</TableCell>
                                    <TableCell>{Strings.celular}</TableCell>
                                    <TableCell>{Strings.telefono}</TableCell>
                                    <TableCell>{Strings.ingresos}</TableCell>
                                    <TableCell>{Strings.dependientes}</TableCell>
                                    <TableCell>{Strings.direccion}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clientes?.map((cliente,index)=>
                                    <TableRow key={index}>
                                        <TableCell>{cliente.nombres}</TableCell>
                                        <TableCell>{cliente.apellidos}</TableCell>
                                        <TableCell className={cliente.email?.length && clientes.filter(item=>item.email === cliente.email)?.length > 1 ? "text-red":""}
                                        >{cliente.email}</TableCell>
                                        <TableCell className={!cliente.cedula?.length || clientes.filter(item=>item.cedula === cliente.cedula)?.length > 1 ? "text-red":""}
                                        >{cliente.cedula ?? "Requerido"}</TableCell>
                                        <TableCell>{cliente.sexo === "F"?"Femenino":"Masculino"}</TableCell>
                                        <TableCell>{!!cliente.fechaNacimiento && formatDate(cliente.fechaNacimiento)}</TableCell>
                                        <TableCell>{cliente.celular}</TableCell>
                                        <TableCell>{cliente.telefono}</TableCell>
                                        <TableCell>{formatPeso(cliente.ingresos)}</TableCell>
                                        <TableCell>{cliente.dependientes}</TableCell>
                                        <TableCell className={"comment"}>{cliente.direccion}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={close} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                {!!clientes?.length && <Button color="primary" onClick={submit} variant={"outlined"}>{Strings.guardar}</Button>}
            </DialogActions>
        </Dialog>
    </>;
}
